import { Sparkles } from "lucide-react";

import { Button } from "@/components/ui";
import { cn } from "@/utils/cn";

import type { CreateForm } from "../hooks/useCreateForm";

interface Props {
  submit: CreateForm["submit"];
}

export const GenerateButton = ({ submit }: Props) => {
  const enabled = submit.canGenerate && !submit.isSubmitting;
  return (
    <Button
      onClick={submit.handleGenerate}
      disabled={!enabled}
      className={cn(
        "h-16 w-full text-base sm:text-lg",
        enabled
          ? "hover:-translate-y-0.5"
          : "cursor-not-allowed bg-zinc-300 text-zinc-600",
      )}
    >
      <Sparkles className="h-5 w-5" />
      {submit.isSubmitting ? "Sending..." : submit.generateButtonLabel}
    </Button>
  );
};
